import React from 'react'
import { observer } from 'mobx-react'
import debounce from 'lodash/debounce'
import { Row, Col } from 'react-bootstrap'
import { APPConfig } from 'config/appConfig'
import { customerContainer } from 'src/models'
import { i18nTranslate, application } from 'src/utils'
import {
  Quantity,
  SubscriptionDropDown,
  ImageComponent,
} from 'src/views/components'
import { transformCartSubscriptionProductData } from '../deps'
import { SubscriptionProductUnitPrice } from './SubscriptionProductUnitPrice'
import './styles.scss'
import { overlayState } from 'src/views/components/Overlay'
@observer
class SubscriptionModalProductDetails extends React.Component {
  renderFrequency = (subscriptionItem = {}) => {
    const {
      quantity = 0,
      itemId = 0,
      subscription = {},
    } = subscriptionItem || {}
    const { frequencyPeriod = '', frequencyType = '' } = subscription || {}
    const { handleItemFrequencyChange = function () {} } = this.props

    return (
      <div
        className="subscription-frequency-wrapper"
        data-testid="qa-subscription-product-frequency-wrapper">
        <SubscriptionDropDown
          frequencyPeriod={frequencyPeriod}
          frequencyType={frequencyType}
          itemId={itemId}
          quantity={quantity}
          handleSubscriptionChange={handleItemFrequencyChange}
          isToShowNewFrequencyStyling={true}
        />
      </div>
    )
  }

  renderQuantity = (subscriptionItem = {}) => {
    const maxLimit = APPConfig?.getAppConfig()?.cartMaxLimit || 99
    const { quantity = 0, itemId = 0, productId = '' } = subscriptionItem
    const { handleItemQuantityChange = function () {} } = this.props

    const productQualificationResponse =
      customerContainer?.qualificationResponse?.qualification?.filter?.(p => {
        return p?.productId === productId
      })

    const maxQuantity =
      productQualificationResponse?.[0]?.quantity > maxLimit
        ? maxLimit
        : productQualificationResponse?.[0]?.quantity
    const customClassName = 'justify-content-start'
    const quantityTitle = i18nTranslate('productCard.quantity', 'Quantity', {
      isNextGenTranslations: true,
    })

    return (
      <Row
        noGutters
        className={`${customClassName} subscription-quantity-wrapper`}
        data-testid="qa-subscription-product-quantity-wrapper">
        <div className="d-flex align-items-center text-uppercase break-word quantity-title">
          {quantityTitle}
        </div>
        <div>
          <Quantity
            defaultValue={quantity}
            maxValue={maxQuantity}
            onQuantityChange={debounce(async (count, cbk) => {
              overlayState.showLoader()
              const response = await handleItemQuantityChange(count, itemId)
              if (cbk) {
                cbk(response)
              }
            }, 700)}
            resetQtyOnFailure={true}
            isV2QuantityStyle={true}
          />
        </div>
      </Row>
    )
  }

  renderQuantityAndFrequency = (subscriptionItem = {}) => {
    return (
      <div className="quantity-frequency-wrapper">
        {this.renderQuantity(subscriptionItem)}
        {this.renderFrequency(subscriptionItem)}
      </div>
    )
  }

  renderProductPrice = (subscriptionItem = {}) => {
    const {
      unitValue = {},
      type = '',
      isSpecialProduct = false,
    } = subscriptionItem

    return (
      <SubscriptionProductUnitPrice
        priceInfo={unitValue}
        isCurrencySymbolRequired={true}
        isBundle={isSpecialProduct}
        type
      />
    )
  }

  renderProductSkuDetails = (skuId = '') => {
    const skuTitle = i18nTranslate('productCard.sku', 'SKU', {
      isNextGenTranslations: true,
    })

    return (
      <div
        className="subscription-sku-details"
        data-testid="qa-subscription-product-sku">
        <span className="subscription-sku-title">{skuTitle}</span>
        <span className="subscription-sku-id">{skuId}</span>
      </div>
    )
  }

  renderProductDetails = (subscriptionItem = {}) => {
    const { productName = '', skuId = '' } = subscriptionItem
    return (
      <div className="product-details">
        <div
          className="subscription-product-name"
          data-testid="qa-subscription-product-name">
          {productName}
        </div>
        {this.renderProductSkuDetails(skuId)}
        {this.renderProductPrice(subscriptionItem)}
      </div>
    )
  }

  renderProductImage = (subscriptionItem = {}) => {
    const { imageURL = '', productName = '' } = subscriptionItem
    return (
      <div
        className="subscription-product-image-wrapper"
        data-testid="qa-subscription-product-image-wrapper">
        <ImageComponent
          testid="qa-subscription-product-image"
          src={imageURL}
          alt={productName}
          height={'62px'}
          width={'62px'}
        />
      </div>
    )
  }

  renderSubscriptionProductDetails = (subscriptionItem = {}) => {
    console.log('**subsItem', subscriptionItem)
    const productDetails =
      transformCartSubscriptionProductData(subscriptionItem)
    console.log('**prdtDetails', productDetails)
    return (
      <div className="subscription-product-info">
        <Row noGutters className="subscription-product-info-row">
          <Col xs={3} sm={2}>
            {this.renderProductImage(productDetails)}
          </Col>
          <Col xs={9} sm={10} className="item-details-wrapper">
            {this.renderProductDetails(productDetails)}
            {!application.isMobile &&
              this.renderQuantityAndFrequency(productDetails)}
          </Col>
        </Row>
        {application.isMobile &&
          this.renderQuantityAndFrequency(productDetails)}
      </div>
    )
  }

  render() {
    const { cartSubscriptionList = [] } = this.props

    return cartSubscriptionList?.map((subscriptionItem, index) => {
      return (
        <div
          key={subscriptionItem?.itemId}
          className="subscription-product-details-wrapper">
          {this.renderSubscriptionProductDetails(subscriptionItem)}
        </div>
      )
    })
  }
}

export { SubscriptionModalProductDetails }
export default SubscriptionModalProductDetails
